import { render, staticRenderFns } from "./PlaceContent.vue?vue&type=template&id=6c4e1d1f"
import script from "./PlaceContent.vue?vue&type=script&lang=js"
export * from "./PlaceContent.vue?vue&type=script&lang=js"
import style0 from "./PlaceContent.vue?vue&type=style&index=0&id=6c4e1d1f&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports